import { Injectable } from '@angular/core';
import {
  DepartamentoRegional,
  Regiao,
  RegioesUnidadesData,
  UnidadeOperacional,
} from '../../models/RegioesUnidadesInterface';
import regioesUnidades from '../../../assets/json/regioes-unidades-sesi.json';

@Injectable({
  providedIn: 'root',
})
export class RegioesUnidadesService {
  private data: RegioesUnidadesData = regioesUnidades;

  constructor() {}

  carregarDados(): RegioesUnidadesData {
    return this.data;
  }

  getDepartamentosRegionais(): DepartamentoRegional[] {
    return this.data.departamentosRegionais;
  }

  getRegioesPorDepartamento(departamento: string): Regiao[] {
    const depto = this.data.departamentosRegionais.find(
      (d) => d.nome === departamento
    );
    return depto ? depto.regioes : [];
  }

  getUnidadesPorRegiao(
    departamento: string,
    regiao: string
  ): UnidadeOperacional[] {
    const regioes = this.getRegioesPorDepartamento(departamento);
    const reg = regioes.find((r) => r.nome === regiao);
    return reg ? reg.unidadesOperacionais : [];
  }

  getTodasUnidadesOperacionais(): UnidadeOperacional[] {
    return this.data.departamentosRegionais.flatMap((depto) =>
      depto.regioes.flatMap((regiao) => regiao.unidadesOperacionais)
    );
  }

  getUnidadePorCodigo(codigo: string): UnidadeOperacional | undefined {
    return this.getTodasUnidadesOperacionais().find((u) => u.codigo === codigo);
  }

  getUnidadePorNome(nome: string): UnidadeOperacional | undefined {
    return this.getTodasUnidadesOperacionais().find((u) => u.nome === nome);
  }

  // Método auxiliar para obter o nome completo da unidade (código + nome)
  getNomeCompletoUnidade(codigo: string): string {
    const unidade = this.getUnidadePorCodigo(codigo);
    return unidade ? `${unidade.codigo} - ${unidade.nome}` : '';
  }
}
